import { Link, useOutletContext } from 'react-router-dom';
import { ClipboardList, CalendarClock, Package, Truck, CalendarCheck, Wallet, Lock, ChevronRight, ScanLine } from 'lucide-react';

const TOOLS = [
  { key: 'scan_pos', to: 'scan-pos', icon: ScanLine, title: 'Scan to POS', text: 'Medicine codes, opened packs and prescriptions' },
  { key: 'stocktake', to: 'stocktake', icon: ClipboardList, title: 'Stock take', text: 'Scan or type to count shelves' },
  { key: 'stocktake', to: 'pack-counts', icon: ScanLine, title: 'Opened-pack counts', text: 'Physical counts and approved adjustments' },
  { key: 'products_edit', to: 'shelf-moves', icon: Package, title: 'Shelf & bin moves', text: 'Confirmed locations and movement history' },
  { key: 'products_view', to: 'stock-insights', icon: ClipboardList, title: 'Stock insights', text: 'Pack age, usage, waste and suggestions' },
  { key: 'products_view', to: 'printer-profiles', icon: Package, title: 'Label profiles', text: 'Printer sizes and calibration' },
  { key: 'products_view', to: 'products', icon: Package, title: 'Products', text: 'Look up and edit name, expiry, maker, quantity' },
  { key: 'expiry', to: 'expiry', icon: CalendarClock, title: 'Expiry sweep', text: 'Scan shelves to find stock expiring in 90 days' },
  { key: 'receiving', to: 'receiving', icon: Truck, title: 'Receive deliveries', text: 'Pre-check supplier deliveries against POs' },
  { key: 'leave_access', to: 'leave', icon: CalendarCheck, title: 'Leave', text: 'Request leave or decide pending ones', badgeKey: 'my_leave_updates' },
  { key: 'payslips', to: 'payslips', icon: Wallet, title: 'My payslips', text: 'View and open your payslips' },
];

export default function StaffAppToolsPage() {
  const { tools, feed } = useOutletContext();
  return (
    <div className="px-4 py-4 space-y-2.5" data-testid="staff-app-tools">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-1">Tools</p>
      {TOOLS.map(({ key, to, icon: Icon, title, text, badgeKey }) => {
        const allowed = tools ? tools[key] : false;
        const badge = badgeKey && feed ? Number(feed[badgeKey] || 0) : 0;
        const subtitle = !allowed
          ? 'No access — ask your admin'
          : key === 'products_view' && !tools.products_edit ? 'Look up products (view only)'
          : key === 'leave_access' && !tools.leave_view ? 'Request leave and see your status'
          : text;
        const body = (
          <>
            <span className={`relative w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${allowed ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'}`}>
              <Icon className="w-5 h-5" />
              {!!badge && allowed && (
                <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-bold flex items-center justify-center"
                  data-testid={`staff-app-tool-${to}-badge`}>
                  {badge > 9 ? '9+' : badge}
                </span>
              )}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold">{title}</span>
              <span className="block text-xs text-muted-foreground truncate">{subtitle}</span>
            </span>
            {allowed ? <ChevronRight className="w-4 h-4 text-muted-foreground" /> : <Lock className="w-4 h-4 text-muted-foreground" />}
          </>
        );
        const cls = 'staff-app-feed-item flex items-center gap-3 rounded-xl border border-border bg-card px-3.5 py-3';
        return allowed
          ? <Link key={to} to={to} className={`${cls} hover:bg-muted/50`} data-testid={`staff-app-tool-${to}`}>{body}</Link>
          : <div key={to} className={`${cls} opacity-60`} data-testid={`staff-app-tool-${to}-locked`}>{body}</div>;
      })}
    </div>
  );
}
